module.exports = __webpack_public_path__ + "static/media/urbanIcon1.71823b9a.svg";